import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bank",
  "use": "bank-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"bank\"><path d=\"M28 12h4L16 0 0 12h4v14H2v6h28v-6h-2zm-3 14h-4V12h4zm-7 0h-4V12h4zM16 2.5L26 10H6zM7 12h4v14H7zm21 18H4v-2h24z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/bank.svg
// module id = yIOn
// module chunks = 39 44